<template>
  <div class="container">
    <div v-if="false">
      <div class="dashboard__row">
        <dashboard-urls></dashboard-urls>
      </div>
      <div class="dashboard__row">
        <dashboard-calendar></dashboard-calendar>
      </div>
      <div class="dashboard__row">
        <overview hideTable></overview>
      </div>
      <div class="dashboard__row dashboard__relevancy">
        <relevancy-report></relevancy-report>
      </div>
    </div>
  </div>

</template>

<script>
import RelevancyReport from '../reports/relevancy/RelevancyReport'
import Overview from '../reports/rank-zone/overview/Overview'
import DashboardCalendar from './DashboardCalendar'
import DashboardUrls from './DashboardUrls'

/**
 * It's component that is absent in final version of the application.
 * This one may be in demand in the future
 */
export default {
  name: 'Dashboard',
  components: { DashboardUrls, DashboardCalendar, Overview, RelevancyReport }
}
</script>

<style scoped lang="scss">
  .dashboard {
    &__row {
      margin-bottom: 30px;
    }
    &__row-title{
      margin: 24px 40px;
    }
    &__relevancy{
      margin-top: 60px;
    }
  }

</style>
